// External deps
import PropTypes from 'prop-types';

// Internal deps
import { ModalGeneric } from 'ypf-pas-general-ui-components';

const ModalInfo = ({
    showModalInfo,
    setShowModalInfo,
    secondaryActionLabel,
    primaryActionLabel,
    primaryAction,
    secondaryAction,
    strongMessage,
    spanMessage,
    title,
    infoModal,
    size
  
  }) => {
    const onCloseModal = () => {
      setShowModalInfo(false);
    };
  
    return (
      <ModalGeneric
        title={title}
        infoModal={infoModal}
        show={showModalInfo}
        onHide={onCloseModal}
        backdrop="static"
        size={size}
        primaryActionLabel={primaryActionLabel}
        primaryAction={primaryAction}
        secondaryActionVariant="outline-primary"
        secondaryActionLabel={secondaryActionLabel}
        secondaryAction={secondaryAction}
      >
        <div className="adm-modal-container">
          <p>
            <span>
              <strong>
                {strongMessage}
              </strong>
            </span>
            <br />
            <span>{spanMessage}</span>
          </p>
        </div>
      </ModalGeneric>
    );
  };
  
  ModalInfo.propTypes = {
    setShowModalInfo: PropTypes.func,
    showModalInfo: PropTypes.bool,
    primaryAction: PropTypes.func,
    secondaryAction: PropTypes.func,
    strongMessage: PropTypes.string,
    spanMessage: PropTypes.string,
    secondaryActionLabel: PropTypes.string,
    primaryActionLabel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    infoModal: PropTypes.bool,
    size: PropTypes.string
  };
  ModalInfo.defaultProps = {
    setShowModalInfo: () => {},
    showModalInfo: false,
    primaryAction: () => {},
    secondaryAction: () => {},
    strongMessage: '',
    spanMessage: '',
    secondaryActionLabel: '',
    infoModal: false,
    size: 'xs'
  };
  
  export default ModalInfo;
  